import React, { Component } from "react";
import Footer from "./sub_components/main/footer";
import Datetime from 'react-datetime';
import Header from "./sub_components/main/header";
import { CSVLink } from "react-csv";
import { BASE_IMAGE_PATH_NEW } from "../configs/api";
import * as activityLogsService from '../services/activityLogs'
import { connect } from "react-redux";

class ActivityLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updateBy: "",
      operationType: "",
      ipAddress: "",
      fromDate: "",
      toDate: "",
      shortFild: "username",
      shortType: "asc",
      searchText: "",
      showData: false,
      loader: false,
      activityLogsList: [],
    };
  }

  onChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  }

  onDateTimeChange(name, e) {
    this.setState({ [name]: e._d });
  }

     onSearch(e) {
      this.setState({ searchText: e.target.value })
   }

  componentDidMount() {
    // this.getAffiliateClientLst();
    let userData = localStorage.getItem("tokenData");
    userData = JSON.parse(userData);
    if (!!userData) {
      //&& !!userData.user_role && userData.user_role === "Admin"
      let curDate = new Date(Date.now()).setSeconds(0, 0);
      let weekDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).setHours(
        0,
        0,
        0,
        0,
      );
      this.setState({ toDate: curDate, fromDate: weekDate });
    } else {
      this.props.history.push("/dashboard");
    }
  }

     clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }

  parseFilterBody() {
      let body = {
        "fromDate": new Date(this.state.fromDate).toISOString(),
        "toDate": new Date(this.state.toDate).toISOString(),
        "operationType" : this.state.operationType ? this.state.operationType : null,
        "ipAddress" : this.state.ipAddress,
        "updateBy" : this.state.updateBy,
      }
      body = this.clean(body);
      return body
   }

      async submitForm() {
         const self = this;
         let body = this.parseFilterBody()
         this.setState({ loader: true, showData: false })
         activityLogsService.getActivityLogsList(body).then((result) => {
            if (!!result) {
               if (!!result.isSuccess) {
                  self.setState({ activityLogsList: result.data, loader: false, showData: true })
               } else {
                  self.setState({ activityLogsList: [],showData: true, loader: false });
                  self.props.notify(result.exception.message, "error")
               }
            }
         })
      }

  onSubmit(e) {
    let diffTime = Math.abs(new Date(this.state.toDate) - new Date(this.state.fromDate))
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays > 31) {
      this.props.notify("Date range must be 1 month.", "error");
    }
    else {
      this.submitForm();
    }
  }

  shortUser(field, sortType) {
    let userList = [...this.state.activityLogsList]; // clone array

    userList.sort((a, b) => {
      let valA = a[field];
      let valB = b[field];

      // Handle date field
      if (field === "createdAt") {
        valA = new Date(valA);
        valB = new Date(valB);
      }

      if (valA > valB) return sortType === "asc" ? 1 : -1;
      if (valA < valB) return sortType === "asc" ? -1 : 1;
      return 0;
    });

    this.setState({ activityLogsList: userList });
  }

  resetForm() {
    let curDate = new Date(Date.now()).setSeconds(0, 0)
    let weekDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
    this.setState({
      fromDate: weekDate,
      toDate: curDate,
      updateBy: "",
      ipAddress: "",
      operationType: "",
      showData: false
    })
  }

  getFilteredActivityData() {
    let rtnvl = [...this.state.activityLogsList];

    if (!!this.state.searchText) {
      const search = this.state.searchText.toLowerCase();

      rtnvl = rtnvl.filter((itm) =>
        (itm.updateBy && itm.updateBy.toLowerCase().includes(search)) ||
        (itm.operationType && itm.operationType.toLowerCase().includes(search)) ||
        (itm.ipAddress && itm.ipAddress.includes(search)) ||
        (itm.message && itm.message.toLowerCase().includes(search)) ||
        (itm.createdAt && itm.createdAt.toLowerCase().includes(search))
      );
    }

    return rtnvl;
  }


  render() {
    let activityList = this.getFilteredActivityData();
    return (
      <div className="bethubs">
        <Header history={this.props.history} />
        <div className="wrapper">
          <div className="container-fluid container-padding-0">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="main-box">
                  <div>
                    <h5 className="text-blue  mb-2">
                      <span>Activity Logs</span>
                      <div className="row user-header">
                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                          <div className="form-group font-12">
                            <Datetime
                              value={this.state.fromDate}
                              onChange={(e) => this.onDateTimeChange("fromDate", e)}
                              id="fromDate_datetime"
                              dateFormat={"DD/MM/YYYY"}
                              timeFormat={"HH:mm"}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                          <div className="form-group font-12">
                            <Datetime
                              value={this.state.toDate}
                              onChange={(e) => this.onDateTimeChange("toDate", e)}
                              id="toDate_datetime"
                              dateFormat={"DD/MM/YYYY"}
                              timeFormat={"HH:mm"}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                          <div className="form-group font-12">
                              <input
                                className="form-control  d-inline-block"
                                onChange={(e) => {
                                  this.onChange(e);
                                }}
                                type="text"
                                placeholder="Updated By"
                                name="updateBy"
                                value={this.state.updateBy}
                              />
                          </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                          <div className="form-group font-12">
                            <input
                              className="form-control  d-inline-block"
                              onChange={(e) => {
                                this.onChange(e);
                              }}
                              type="text"
                              placeholder="IP Address"
                              name="ipAddress"
                              value={this.state.ipAddress}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                          <div className="form-group font-12">
                            <select
                              className="form-control d-inline-block"
                              name="operationType"
                              value={this.state.operationType}
                              onChange={(e) => {
                                this.onChange(e);
                              }}
                            >
                              <option value="">All Operations</option>
                              <option value="SIGNUP">Signup</option>
                              <option value="CHANGE_PASSWORD">Change Password</option>
                              <option value="FORGOT_PASSWORD">Forgot Password</option>
                              <option value="RESET_PASSWORD">Reset Password</option>
                              <option value="ADD">Add</option>
                              <option value="UPDATE">Update</option>
                              <option value="AFFILATE_APPROVED">Affilate Approved</option>
                              <option value="AFFILATE_REJECTED">Affilate Rejected</option>
                              <option value="SENT_OTP">Sent Otp</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                          <div
                            className="btn-group"
                            role="group"
                            aria-label="Basic example"
                            id="divpagecount"
                          >
                            <button
                              className="btn btn-blue"
                              disabled={!!this.state.fromDate && !!this.state.toDate ? false : true}
                              onClick={(e) => this.onSubmit(e)}
                            >
                              Go
                            </button>
                            <button
                              className="btn btn-blue ml-1"
                              onClick={(e) => this.resetForm()}
                            >
                              Reset
                            </button>
                          </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2"></div>
                      </div>
                      <div className="row user-header">
                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                          <div className="d-flex float-left">
                            <div className="form-group mb-0 d-inline">
                              <input
                                className="form-control  d-inline-block"
                                onChange={(e) => {
                                  this.onSearch(e);
                                }}
                                type="text"
                                placeholder="Search"
                                aria-label="Search"
                                value={this.state.searchText}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </h5>
                  </div>

                  <div className="row mt-1">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 table-responsive">
                      {!this.state.showData && this.state.loader ? (
                        <span>Loading...</span>
                      ) : this.state.showData ? (
                        <>
                          <table
                            id="example"
                            className="table table-striped table-bordered table-sm addpadding nowrap"
                            style={{ width: "100%" }}
                          >
                            <thead>
                              <tr>
                                <th>Sr.</th>
                                <th>
                                  <span>Date & Time</span>
                                  <span className="d-contant" style={{ float: "right" }}>
                                    <span onClick={() => this.shortUser("createdAt", "asc")} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                    <span onClick={() => this.shortUser("createdAt", "desc")} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                  </span>
                                </th>

                                <th>
                                  <span>Updated By</span>
                                  <span className="d-contant" style={{ float: "right" }}>
                                    <span onClick={() => this.shortUser("updateBy", "asc")} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                    <span onClick={() => this.shortUser("updateBy", "desc")} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                  </span>
                                </th>

                                <th>
                                  <span>Operation</span>
                                  <span className="d-contant" style={{ float: "right" }}>
                                    <span onClick={() => this.shortUser("operationType", "asc")} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                    <span onClick={() => this.shortUser("operationType", "desc")} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                  </span>
                                </th>

                                <th>
                                  <span>IP Address</span>
                                  <span className="d-contant" style={{ float: "right" }}>
                                    <span onClick={() => this.shortUser("ipAddress", "asc")} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                    <span onClick={() => this.shortUser("ipAddress", "desc")} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                  </span>
                                </th>
                                <th>
                                  <span>Message</span>
                                  <span className="d-contant" style={{ float: "right" }}>
                                    <span onClick={() => this.shortUser("message", "asc")} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                    <span onClick={() => this.shortUser("message", "desc")} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                  </span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {!!activityList && activityList.length > 0 ? activityList.map((item, i) => {
                                return (
                                  <>
                                    <tr>
                                      <td>{i + 1}</td>
                                      <td>
                                        <span>
                                          {new Date(item.createdAt).toLocaleString()}
                                        </span>
                                      </td>

                                      <td>
                                        <span>{item.updateBy}</span>
                                      </td>

                                      <td>
                                        <span>{item.operationType.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())}</span>
                                      </td>

                                      <td>
                                        <span>{item.ipAddress}</span>
                                      </td>

                                      <td>
                                        <span>{item.message}</span>
                                      </td>
                                    </tr>
                                    {/* } */}
                                  </>
                                );
                              }) :
                              <td colSpan={6} align="center">
                                No Data Found.
                              </td>
                            }
                            </tbody>
                          </table>
                        </>
                      ) : (
                        <span> No Record Found.</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(ActivityLogs);
